"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { CICType, CIC_TO_TEXT } from "@/entities/IProfile";
import { cicToType } from "@/helpers/Helpers";
interface Props {
  readonly cic: number;
}
export const CIC_META: Record<CICType, {
  title: string;
  class: string;
}> = {
  [CICType.INACCURATE]: {
    title: CIC_TO_TEXT[CICType.INACCURATE],
    class: "tw-text-[#F97066]"
  },
  [CICType.UNKNOWN]: {
    title: CIC_TO_TEXT[CICType.UNKNOWN],
    class: "tw-text-[#FEDF89]"
  },
  [CICType.PROBABLY_ACCURATE]: {
    title: CIC_TO_TEXT[CICType.PROBABLY_ACCURATE],
    class: "tw-text-[#AAF0C4]"
  },
  [CICType.ACCURATE]: {
    title: CIC_TO_TEXT[CICType.ACCURATE],
    class: "tw-text-[#73E2A3]"
  },
  [CICType.HIGHLY_ACCURATE]: {
    title: CIC_TO_TEXT[CICType.HIGHLY_ACCURATE],
    class: "tw-text-emerald-400"
  }
};
export default function UserCICStatus(props) {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.cic) {
    t0 = cicToType(props.cic);
    $[0] = props.cic;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [cicType, setCicType] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== props.cic) {
    t1 = () => {
      setCicType(cicToType(props.cic));
    };
    t2 = [props.cic];
    $[2] = props.cic;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = CIC_META[cicType];
  const t4 = CIC_META[cicType];
  let t5;
  if ($[5] !== t3.class || $[6] !== t4.title) {
    t5 = <span className={t3.class}>{t4.title}</span>;
    $[5] = t3.class;
    $[6] = t4.title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}